module.exports = __webpack_public_path__ + "media/images/smart_phone/products/ninjin2-3e9e55121eec930b26b328e11cd7264f.jpeg";